import { useMemo } from 'react'
import _ from 'lodash'

export default (formik, name) => {
  const value = useMemo(() => {
    return _.get(formik?.values, name)
  }, [formik.values, name])

  function setValue(newValue) {
    formik.setFieldValue(
      name,
      _.isFunction(newValue) ? newValue(value) : newValue
    )
  }

  return [value, setValue]
}
